import { CarAreaCode } from '@/utils/constants';
import React, { FC } from 'react';

interface SplashCarExteriorProps {
  width?: number;
  area?: CarAreaCode;
  onClick?: (damageArea?: CarAreaCode) => void;
}

export const SplashCarExterior: FC<SplashCarExteriorProps> = ({
  width,
  area,
  onClick,
}) => {
  const imageWidth = width || 300;
  const areas: { code: CarAreaCode; style: React.CSSProperties }[] = [
    {
      code: CarAreaCode.OD01,
      style: { top: 0, width: '50%', height: '14%', margin: '0 25%' },
    },
    {
      code: CarAreaCode.OD02,
      style: { top: '11%', width: '34%', height: '23%' },
    },
    {
      code: CarAreaCode.OD03,
      style: { top: '14%', left: '34%', width: '32%', height: '30%' },
    },
    {
      code: CarAreaCode.OD04,
      style: { top: '11%', right: 0, width: '34%', height: '23%' },
    },
    {
      code: CarAreaCode.OD05,
      style: { top: '34%', width: '34%', height: '20%' },
    },
    {
      code: CarAreaCode.OD06,
      style: { top: '44%', left: '34%', width: '32%', height: '23%' },
    },
    {
      code: CarAreaCode.OD07,
      style: { top: ' 34%', right: 0, width: '34%', height: '20%' },
    },
    {
      code: CarAreaCode.OD08,
      style: { top: '54%', width: '34%', height: '17%' },
    },
    {
      code: CarAreaCode.OD09,
      style: { top: '67%', left: '34%', width: '32%', height: '21%' },
    },
    {
      code: CarAreaCode.OD10,
      style: { top: '54%', right: 0, width: '34%', height: '17%' },
    },
    {
      code: CarAreaCode.OD11,
      style: { top: '71%', width: '34%', height: '17%' },
    },
    {
      code: CarAreaCode.OD12,
      style: { top: '88%', left: '30%', width: '40%', height: '12%' },
    },
    {
      code: CarAreaCode.OD13,
      style: { top: '71%', right: 0, width: '34%', height: '17%' },
    },
  ];

  return (
    <div style={{ width: imageWidth, height: (404.5 * imageWidth) / 300 }}>
      <div className="d-flex w-100 position-relative">
        <img className="w-100" src="images/splash-car-exterior.png" />
        {areas.map((o) => (
          <div
            style={{
              position: 'absolute',
              ...o.style,
              background: area === o.code ? 'rgba(0,0,0,0.45)' : undefined,
              cursor: onClick ? 'pointer' : 'default',
            }}
            onClick={() => onClick?.(area === o.code ? undefined : o.code)}
          ></div>
        ))}
      </div>
    </div>
  );
};
